import { AbstractStep, type AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import React from "react";
import type { ReactNode } from "react";
import { Button, Card } from "react-bootstrap";

interface Props extends AbstractStepProps {
	koMessage: string;
}

export class KoPage extends AbstractStep<{}, Props> {
	protected renderContent(): ReactNode {
		const { koMessage } = this.props;

		return (
			<>
				<Card.Body className="text-center bg-success-700 text-white">
					<p className="font-weight-bold text-gold">
						A megadott adatok alapján sajnos nem vagy jogosult a kért CSOK Pluszra.
					</p>
					<p>{koMessage}</p>
				</Card.Body>
				<Card.Footer className="bg-success">
					<p className="d-block text-white font-weight-bold">
						Nézd meg a Bankmonitor kalkulátorával, hogy milyen piaci kölcsönök érhetők el számodra.
					</p>
					<Button
						variant="gold"
						block
						href="/lakashitel-kalkulator/"
						onClick={() => this.sendEvent("BM_openCalculator")}
					>
						Kalkulátor megnyitása
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "KoPage";
	}
}
